/**
 * A hero caption with an “i” that opens what the figure means.
 *
 * Used on every studio section header that publishes a named count or amount —
 * Tasks, Clients, Money, Analytics, client detail — so the strip can stay short
 * without losing the explanation.
 */

import { Popover } from '../portal/Overlay.js'
import { HeroCap } from '../portal/Text.js'

export type HeroCapInfoProps = {
  readonly label: string
  readonly tip: string
}

export function HeroCapInfo({ label, tip }: HeroCapInfoProps) {
  return (
    <div className="hero-cap-info">
      <HeroCap>{label}</HeroCap>
      <Popover
        trigger={
          <button type="button" className="hero-cap-info__btn" aria-label={`What “${label}” means`}>
            i
          </button>
        }
      >
        <p className="small">{tip}</p>
      </Popover>
    </div>
  )
}
